import {
  ITranslationMap,
  type ICustomMappingSourceOption,
} from '@principle-theorem/practice-migrations/interfaces';
import {
  type AtLeast,
  type IXSLXExport,
  type XSLXCell,
} from '@principle-theorem/shared';
import type { Column } from 'exceljs';
import { IMedicalHistoryOption } from './allergy-to-medical-history-to-xlsx';

export interface IMedicalConditionToMedicalHistoryXSLX {
  sourceId: string;
  sourceName: string;
  mapTo: string;
}

export const MEDICAL_CONDITION_TO_MEDICAL_HISTORY_HEADERS: AtLeast<
  Column,
  'key' | 'header'
>[] = [
  {
    key: 'sourceId',
    header: 'Id',
  },
  {
    key: 'sourceName',
    header: 'Medical Condition Name',
    width: 45,
  },
  {
    key: 'mapTo',
    header: 'Map To',
    width: 30,
  },
];

export class MedicalConditionToMedicalHistoryToXSLX
  implements
    IXSLXExport<
      ICustomMappingSourceOption,
      IMedicalConditionToMedicalHistoryXSLX
    >
{
  headers = MEDICAL_CONDITION_TO_MEDICAL_HISTORY_HEADERS;

  constructor(
    private _medicalHistoryOptions: IMedicalHistoryOption[],
    private _existingMappings: ITranslationMap<object, string>[]
  ) {}

  translate(
    records: ICustomMappingSourceOption[]
  ): Record<keyof IMedicalConditionToMedicalHistoryXSLX, XSLXCell>[] {
    return records.map((record) => {
      const existingRecord = this._existingMappings.find(
        (existingMapping) => existingMapping.sourceLabel === record.label
      );

      const destinationValue = existingRecord?.destinationValue?.value;
      const mappedValue = destinationValue
        ? this._medicalHistoryOptions.find(
            (medicalHistoryOption) =>
              medicalHistoryOption.destinationValue.value ===
                existingRecord.destinationValue?.value &&
              medicalHistoryOption.associatedValue ===
                existingRecord.associatedValue
          )
        : undefined;

      return {
        sourceId: {
          value: record.value,
        },
        sourceName: {
          value: record.label,
        },
        mapTo: {
          value: mappedValue?.label,
          dataValidation: {
            type: 'list',
            formulae: [
              `"${this._medicalHistoryOptions
                .map((medicalHistoryOption) => medicalHistoryOption.label)
                .join(',')}"`,
            ],
          },
        },
      };
    });
  }
}
